<article>
  <section>
    <div class="products-container">
      <app-products #productComponent *ngIf="products.length" [products]="products" (productSelected)="onProductSelected($event)"></app-products>
    </div>
    <app-subtitles #subtitles></app-subtitles>
    <button (click)="noInterest()" class="noInterest" *ngIf="products.length">No me interesa</button>
  </section>
  <footer>
    <app-speech #speechComponent actionButton="loading"></app-speech>
  </footer>
</article>
